import { createAsyncThunk } from '@reduxjs/toolkit';
import { setAlert } from '../Alert/alertSlice';
import {
  addComputerImages,
  addImage,
  setUploadedImageInTab,
  toggleModal,
} from './imageSlice';
import { httpGet, httpPost } from '@/utils/helpers/httpHelperPartner';
import CONFIG from 'config';
import { Data } from './types';

export const fetchGalleryImages: any = createAsyncThunk(
  'images/fetchGalleryImages',
  async ({
    page,
    search,
    orderBy,
    direction,
    type,
  }: {
    page: string;
    search: string;
    orderBy: string;
    direction: string;
    type: string;
  }) => {
    const { data: galleryData } = await httpGet<{ data: Data }>(
      CONFIG.ENDPOINTS.images +
        `?page=${page}&limit=5&search=${search}&orderBy=${orderBy}&direction=${direction}&businessType=${type}`
    );
    return galleryData.data;
  }
);

export const postGalleryImage: any = createAsyncThunk(
  'images/postGalleryImage',
  async (file: any, { rejectWithValue, dispatch }) => {
    try {
      let formData = new FormData();
      formData.append('images', file.file);
      formData.append('businessType', file.type);
      let response: any = await httpPost(
        CONFIG.ENDPOINTS.images + '/',
        formData
      );

      dispatch(
        setUploadedImageInTab({
          file: URL.createObjectURL(file.file),
          path: file.file.path,
          name: file.file.name,
        })
      );

      // do not add images directly to entity from computer tab
      // for approve and decline purposes
      if (!file.tab) {
        dispatch(
          addImage({
            file: URL.createObjectURL(file.file),
            path: file.file.path,
            name: file.file.path,
          })
        );
      } else {
        dispatch(
          addComputerImages({
            file: URL.createObjectURL(file.file),
            path: file.file.path,
            name: file.file.path,
          })
        );
      }
      return response.data.data;
    } catch (error: any) {
      const errorMessage = error?.response?.data.error.validations[0].message;
      dispatch(toggleModal(false));
      dispatch(
        setAlert({
          alertType: 'ERROR',
          message: errorMessage,
        })
      );
      return rejectWithValue(error.response.data);
    }
  }
);
